function HTMLEncode(value) {
  value = value.replace("!", "%21");
  value = value.replace('"', "%22");
  value = value.replace("#", "%23");
  value = value.replace("$", "%24");
  value = value.replace("'", "%27");
  value = value.replace("(", "%28");
  value = value.replace(")", "%29");
  value = value.replace("+", "%2B");
  value = value.replace("&", "%26");
  value = value.replace(",", "%2C");
  value = value.replace("-", "%2D");
  value = value.replace(".", "%2E");
  value = value.replace("/", "%2F");
  value = value.replace(":", "%3A");
  value = value.replace(";", "%3B");
  value = value.replace("<", "%3C");
  value = value.replace("=", "%3D");
  value = value.replace(">", "%3E");
  value = value.replace("@", "%40");
  return value;
}

export function decompose(values) {
  const entries = values.params;
  let vals = "?";

  if (values.tab) {
    for (let [key, value] of Object.entries(entries)) {
      if (value !== null && value) {
        if (key === "nums") {
          value = value.join("||");
        }
        value = encodeURI(value);
        value = HTMLEncode(value);
        vals = vals + `${key}=${value}` + "&";
      }
    }
  } else {
    vals += entries;
  }
  return vals;
}
